import React from "react";
import {Link} from 'react-router-dom';
import newLogo from '../images/newlogo.png';

const Footer = () => {
	const year = new Date().getFullYear();
	return (
		<footer className='footer'>
			<div className='inner-footer'>
				<div className='footer-col footer-brand'>
					<img src={newLogo} alt='Proteam Yönetim'/>
					<p>
						Site ve apartman yönetiminde uçtan uca çözüm sunan
						profesyonel ekibinizle tanışın.
					</p>
				</div>

				<div className='footer-col'>
					<h4>İletişim</h4>
					<ul className='footer-list'>
						<li>
							<a href='tel:05078098989'>
								<i className='fa fa-phone' aria-hidden='true'></i>
								0 (507) 809 89 89
							</a>
						</li>
						<li>
							<a href='tel:05058098989'>
								<i className='fa fa-phone' aria-hidden='true'></i>
								0 (505) 809 89 89
							</a>
						</li>
						<li>
							<a href='tel:05418098989'>
								<i className='fa fa-phone' aria-hidden='true'></i>
								0 (541) 809 89 89
							</a>
						</li>
						<li>
							<a href='mailto:info@proteamyonetim.com'>
								<i className='fa fa-envelope-o' aria-hidden='true'></i>
								info@proteamyonetim.com
							</a>
						</li>
					</ul>

					<h4 style={{marginTop: '28px'}}>Hızlı Erişim</h4>
					<ul className='footer-list'>
						<li><Link to='/'>Ana Sayfa</Link></li>
						<li><Link to='/hizmetlerimiz'>Hizmetlerimiz</Link></li>
						<li><Link to='/referanslarimiz'>Referanslarımız</Link></li>
						<li><Link to='/iletisim'>İletişim</Link></li>
					</ul>
				</div>

				<div className='footer-col footer-map'>
					<h4>Ofis</h4>
					<p style={{fontSize: '0.9375rem', lineHeight: 1.7, color: 'rgba(255,255,255,0.65)', marginBottom: '14px'}}>
						Barbaros Caddesi No: 17
						<br/>Küçükçekmece / İstanbul
					</p>
					<iframe
						title='Proteam Yönetim — Ofis Konumu'
						src='https://www.google.com/maps/embed?pb=!4v1777723975591!6m8!1m7!1smX0x7CbOUZ7JZNrrZYRO6g!2m2!1d40.98690179912337!2d28.78007963949387!3f243.48195654979233!4f-2.1144641583182846!5f0.7820865974627469'
						loading='lazy'
						referrerPolicy='no-referrer-when-downgrade'
						allowFullScreen=''
					/>
				</div>
			</div>
			<div className='footer-bottom'>
				<span>© {year} Proteam Yönetim. Tüm hakları saklıdır.</span>
				<span>info@proteamyonetim.com</span>
			</div>
		</footer>
	);
};

export default Footer;
